import styled from 'styled-components'

const CollectionsNav = styled.nav`
  text-align: right;

  width: 100%;

  grid-area: nav;

  display: flex;
  flex-flow: row nowrap;


  height: min-content;

  z-index: 8;

  margin-bottom: 10px;

  position: sticky;
  top: 38px;

  @media (min-width: ${props => props.theme.small}) {
    flex-flow: column nowrap;
    margin-bottom: 0;


      top: 10px;
      position: sticky;
  }
`

export default CollectionsNav



// WEBPACK FOOTER //
// ./src/components/SeasonLabel.js